import type { UnavailableSentinelImageDate } from '@utils/imageAvailability';
import type { EntityAdapter, EntityState } from 'redux-ngrx-entity';
import { createEntityAdapter } from 'redux-ngrx-entity';
import type { RequestStatus } from '../../core/api/state';
import type { CloudOptions, ImageAOI, SceneGroup, Source } from '../../core/models/imageAssets';

export interface CatalogOptions {
  cloudCoverage: number;
  sources: Source[];
  cloudOptions: CloudOptions[];
}

export interface ImageAssetState extends EntityState<SceneGroup> {
  /* Selected states */
  selectedSceneGroupId: string | null;
  selectedSideSceneGroupId: string | null;
  selectedImages: ImageAOI[];
  selectedSideImages: ImageAOI[];
  /* --- */
  sceneCancelToken?: AbortController;
  loadAttempts: number;
  status: RequestStatus;
  droneRequestStatus: RequestStatus;
  showDroneImages: boolean;
  unavailableSentinelImageDates: UnavailableSentinelImageDate[];
  s2bImageExclusionEnabled: boolean;
  compositionStatus: RequestStatus;
  sideCompositionStatus: RequestStatus;
  page: number;
  error: string | null;
  dateRange: [Date, Date];
  dateRangeReport: [Date, Date];
  options: CatalogOptions;
  optionsSide: CatalogOptions;
  readonly assetsCursor: string | null;
  readonly timeToLoad: number | null;
}

export const adapter: EntityAdapter<SceneGroup> = createEntityAdapter<SceneGroup>();
